/* Stop displaying the offer when its Shopify discount expires, including tabs left open. */
(() => {
  const expire = () => {
    const now = Date.now();
    let changed = false;
    document.querySelectorAll('[data-preparedness-ends]').forEach((element) => {
      if (now >= Date.parse(element.dataset.preparednessEnds)) { element.remove(); changed = true; }
    });
    if (changed) document.dispatchEvent(new CustomEvent('preparedness:expired'));
  };
  expire();
  const timer = window.setInterval(() => {
    expire();
    if (!document.querySelector('[data-preparedness-ends]')) window.clearInterval(timer);
  }, 60000);
})();
